import React, { useEffect, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import {
  ManageContainer,
  ManageWrapper,
  MemberContainer,
  ManageHeader,
  AddButton,
} from './manageWaitlistElements';
import LoadingSection from '../Loading';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import axios from '../../Api/axios';

// Tables
import WaitlistTable from '../../Utils/table/waitlistManageTable';
import ReferrerTable from '../../Utils/table/referrerManageTable';

// Popups
import Popup from '../../Utils/popup/popup';
import AddWaitlist from '../../Utils/popup/addWaitlist/addWaitlistPopup';
import AddReferrer from '../../Utils/popup/addReferrer';

const ManageWaitlistSection = () => {
  const axiosPrivate = useAxiosPrivate();

  const [loading1, setLoading1] = useState(true);
  const [loading2, setLoading2] = useState(true);

  const [waitlist, setWaitlist] = useState({});
  const [referrers, setReferrers] = useState([]);

  const [addWaitlistOpen, setAddWaitlistOpen] = useState(false);
  const [addReferrerOpen, setAddReferrerOpen] = useState(false);

  useEffect(() => {
    axiosPrivate.get('/getWaitlist', {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then((res) => {
      setWaitlist(res.data.waitlist);
      setLoading1(false);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  useEffect(() => {
    axios.get(
      '/getReferrers',
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      setReferrers(res.data.referrers);
      setLoading2(false);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  return (
    <ManageContainer>
      <Popup header="Add waitlist member" trigger={addWaitlistOpen} setOpen={setAddWaitlistOpen}>
        <AddWaitlist setOpen={setAddWaitlistOpen} setData={setWaitlist} referrers={referrers} />
      </Popup>
      <Popup header="Add new referrer" trigger={addReferrerOpen} setOpen={setAddReferrerOpen}>
        <AddReferrer setOpen={setAddReferrerOpen} setData={setReferrers} />
      </Popup>
      <ManageWrapper>
        {loading1 ? (
          <LoadingSection isSmall />
        ) : (
          <MemberContainer>
            <ManageHeader>Waitlist</ManageHeader>
            <ManageHeader>{`Total ${waitlist.length} entries`}</ManageHeader>
            <AddButton onClick={() => setAddWaitlistOpen(true)}>
              Add new entry
              <AiOutlinePlus style={{ marginLeft: '5px' }} />
            </AddButton>
            <WaitlistTable
              data={waitlist}
              setData={setWaitlist}
              rowsPerPage={10}
              referrers={referrers}
            />
          </MemberContainer>
        )}
      </ManageWrapper>
      <ManageWrapper>
        {loading2 ? (
          <LoadingSection isSmall />
        ) : (
          <MemberContainer>
            <ManageHeader>Referrers</ManageHeader>
            <ManageHeader>{`Total ${referrers.length} referrers`}</ManageHeader>
            <AddButton onClick={() => setAddReferrerOpen(true)}>
              Add new referrer
              <AiOutlinePlus style={{ marginLeft: '5px' }} />
            </AddButton>
            <ReferrerTable data={referrers} setData={setReferrers} rowsPerPage={10} />
          </MemberContainer>
        )}
      </ManageWrapper>
    </ManageContainer>
  );
};

export default ManageWaitlistSection;
